import { render, staticRenderFns } from "./dept-selector.vue?vue&type=template&id=40a77645&scoped=true&"
import script from "./dept-selector.vue?vue&type=script&lang=js&"
export * from "./dept-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a77645",
  null
  
)

export default component.exports